import React from 'react';
import PropTypes from 'prop-types';
import { Col, FormGroup, Label } from 'reactstrap';
import Select from 'react-select';
import classnames from 'classnames';
import _ from 'lodash';

import 'react-select/dist/react-select.css';

const FormSelect = props => {
  const {
    autoBlur,
    children,
    className,
    classNameContainer,
    clearable,
    closeOnSelect,
    disabled,
    id,
    label,
    multi,
    onChange,
    options,
    required,
    value,
  } = props;

  let selectOptions;
  if (options) {
    selectOptions = options;
  } else {
    let optionChildren = children;
    if (children && !{}.hasOwnProperty.call(children, 'length')) {
      optionChildren = [children];
    }

    selectOptions = _.map(optionChildren, child => ({
      value: child.props.value,
      label: child.props.children,
    }));
  }

  const onChangeFunc = multi
    ? values => onChange(values.map(val => val.value))
    : val => onChange(val ? val.value : val);

  return (
    <FormGroup row className={classnames('form-group-row', classNameContainer)}>
      <div className="form-group-row__label-container">
        <Label for={id} className="form-group-row__label">
          {required ? (
            <span>
              {label} <span className="text-orange">*</span>
            </span>
          ) : (
            label
          )}
        </Label>
      </div>

      <div className="d-flex">
        <Col className="form-group-row__col">
          <Select
            autoBlur={autoBlur}
            className={className}
            clearable={clearable}
            closeOnSelect={closeOnSelect}
            disabled={disabled}
            multi={multi}
            onChange={onChangeFunc}
            options={selectOptions}
            value={value}
          />
        </Col>
      </div>
    </FormGroup>
  );
};

FormSelect.propTypes = {
  autoBlur: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  classNameContainer: PropTypes.string,
  clearable: PropTypes.bool,
  closeOnSelect: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  multi: PropTypes.bool,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({})),
  required: PropTypes.bool,
  value: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.arrayOf(PropTypes.number),
    PropTypes.string,
    PropTypes.number,
  ]),
};

FormSelect.defaultProps = {
  autoBlur: false,
  className: null,
  clearable: false,
  closeOnSelect: true,
  multi: false,
  options: null,
  required: false,
};

export default FormSelect;
